// アクセスAPI定義一覧
const API_URL = {
  USERS: {
    LOGIN: '/api/users/login',
    DOWNLOAD: '/api/users/download',
    AUTH: '/api/users/login/pw',
    ENTRYAUTHSEND: '/api/users/onetime',
    ENTRYAUTH: '/api/users/onetime/auth',
    ENTRY: '/api/users/entry',
    LOGOUT: '/api/users/logout',
    PASSEDIT: '/api/users/password',
    AUTH_GET: '/api/users/auth',
  },
} as const

export default API_URL
